/**************************************************************************************************************************
 Copyright (c) 2023 WorkEarly Results LLP

     Name: firebase.config.js
   Author: Harikrishnan Gangadharan
 Comments: 

/**************************************************************************************************************************
 IMPORTS
***************************************************************************************************************************/
import { initializeApp } from 'firebase/app';
import { getStorage } from 'firebase/storage';
import { getFirestore } from "firebase/firestore";
/**************************************************************************************************************************
 IMPLEMENTATIONS
***************************************************************************************************************************/
const FirebaseConfiguration = {
  apiKey: "AIzaSyA3QL6AIQQSGQB-g-sQQr9Cq552aDOfQVI",
  authDomain: "transcad-75a46.firebaseapp.com",
  projectId: "transcad-75a46",
  storageBucket: "transcad-75a46.appspot.com",
  messagingSenderId: "558810189717",
  appId: "1:558810189717:web:f65bd346cb3b6f6a89709c"
};

const App = initializeApp(FirebaseConfiguration);
const Storage = getStorage(App); 
const StoreDB = getFirestore(App);

const FirebaseService = {
  App,
  Storage,
  StoreDB
}

export default FirebaseService;